import {
  dateOperating
} from '@/cllib/tools'

import {
  invoicingGetData,
  distributionSysWriteoff
} from '@/api/api'

const state = {
  writeoffInvoicingList: [],
  writeoffInvoicingListLoading: false,
  chooseWriteoffInvoicing: {},
  writeoffInvoicingSearchDate: null,
  sysWriteoffIng: false,
  dwPiGasTankId: 0,
  dwLoadPiTag: 1
}

const getters = {
  dwPiGasTankId: state => state.dwPiGasTankId,
  dwLoadPiTag: state => state.dwLoadPiTag,
  writeoffInvoicingList: state => state.writeoffInvoicingList,
  writeoffInvoicingListLoading: state => state.writeoffInvoicingListLoading,
  chooseWriteoffInvoicing: state => state.chooseWriteoffInvoicing,
  chooseWriteoffInvoicingCollectTime: state => state.chooseWriteoffInvoicing.collectTime || null,
  writeoffInvoicingSearchDate: state => state.writeoffInvoicingSearchDate,
  sysWriteoffIng: state => state.sysWriteoffIng
}

const actions = {
  loadWriteoffInvoicingList ({ dispatch, getters }) {
    if (!getters.writeoffInvoicingSearchDate) {
      dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '请选择采集时间'})
      return
    }
    dispatch('setWriteoffInvoicingListLoading', true)
    let parm = {
      gtZero: 0,
      noPage: 1,
      mergeIdnull: 1,
      collectTime: dateOperating.formatDate({date: getters.writeoffInvoicingSearchDate, format: 'yy-mm-dd'}),
      endTime: dateOperating.computeDay({days: 1, date: getters.writeoffInvoicingSearchDate, format: 'yy-mm-dd'})
    }
    return invoicingGetData(parm).then((data) => {
      data.forEach((item) => {
        item.collectTimeS = item.collectTime ? item.collectTime.slice(5, 16) : '--'
        item.outVolume = parseInt(item.outVolume)
        item.inVolume = parseInt(item.inVolume || 0)
        item.disInVolume = parseInt(item.disInVolume || 0)
        item['inVolumeDiff'] = item['inVolume'] - item['disInVolume']
      })
      dispatch('setWriteOffInvoicingList', data)
      dispatch('setWriteoffInvoicingListLoading', false)
    }).catch((e) => {
      dispatch('setWriteoffInvoicingListLoading', false)
    })
  },
  distributionSysWriteoff ({ dispatch, getters }) {
    dispatch('setSysWriteoffIng', true)
    return distributionSysWriteoff(dateOperating.formatDate({date: getters.writeoffInvoicingSearchDate, format: 'yy-mm-dd'})).then((data) => {
      let msg = data && data.length > 0 ? data[0] : null
      if (msg) {
        dispatch('showNoticeMsg', {type: 'info', title: '系统提示', message: msg})
      }
      dispatch('loadWriteoffInvoicingList')
      dispatch('setSysWriteoffIng', false)
    }).catch((e) => {
      dispatch('setSysWriteoffIng', false)
    })
  },
  setSysWriteoffIng ({ commit, getters, dispatch }, data) {
    commit('setSysWriteoffIng', data)
  },
  setWriteoffInvoicingListLoading ({ commit, getters, dispatch }, data) {
    commit('setWriteoffInvoicingListLoading', data)
  },
  setWriteOffInvoicingList ({ commit, getters, dispatch }, data) {
    commit('setWriteOffInvoicingList', data)
  },
  setDwPiGasTankId ({ commit, getters, dispatch }, data) {
    commit('setDwPiGasTankId', data)
    dispatch('updateDwLoadPiTag')
  },
  updateDwLoadPiTag ({ commit, getters }) {
    commit('setDwLoadPiTag', getters.dwLoadPiTag + 1)
  },
  setChooseWriteoffInvoicing ({ commit, dispatch, getters }, data) {
    if (getters.updateWriteoffDistributionNotNull) {
      dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '请先保存已调整数！'})
      return
    }
    commit('setChooseWriteoffInvoicing', data)
    dispatch('setDwPiGasTankId', data.gasTankId)
    dispatch('loadWriteoffRelatedinvoicing')
    dispatch('loadWriteoffDistribution')
  },
  setWriteoffInvoicingSearchDate ({ commit, dispatch }, data) {
    commit('setWriteoffInvoicingSearchDate', data)
  },
  updateWriteoffInvoicingOne ({ commit, dispatch }, data) {
    commit('updateWriteoffInvoicingOne', data)
  }
}

const mutations = {
  setDwLoadPiTag (state, data) {
    state.dwLoadPiTag = data
  },
  setDwPiGasTankId (state, data) {
    state.dwPiGasTankId = data
  },
  setSysWriteoffIng (state, data) {
    state.sysWriteoffIng = data
  },
  setWriteOffInvoicingList (state, data) {
    state.writeoffInvoicingList = data
  },
  setChooseWriteoffInvoicing (state, data) {
    state.chooseWriteoffInvoicing = data
  },
  setWriteoffInvoicingListLoading (state, data) {
    state.writeoffInvoicingListLoading = data
  },
  setWriteoffInvoicingSearchDate (state, data) {
    state.writeoffInvoicingSearchDate = data
  },
  updateWriteoffInvoicingOne (state, data) {
    state.writeoffInvoicingList.forEach((item) => {
      let startTime = dateOperating.computeDay({days: -1, date: item.collectTime, format: 'stamps'})
      let endTime = dateOperating.computeDay({days: 0, date: item.collectTime, format: 'stamps'})
      let hisInTime = data.his.inTime ? dateOperating.formatDate({date: data.his.inTime, format: 'stamps'}) : null
      if (hisInTime && hisInTime > startTime && (hisInTime < endTime || hisInTime === endTime) && item.gasTankId === data.his.gasTankId) {
        item.disInVolume = item.disInVolume - data.his.inVolume
        item['inVolumeDiff'] = parseInt(item['inVolume'] - item['disInVolume'])
      }
      let newInTime = data.new.inTime ? dateOperating.formatDate({date: data.new.inTime, format: 'stamps'}) : null
      if (newInTime && newInTime > startTime && (newInTime < endTime || newInTime === endTime) && item.gasTankId === data.new.gasTankId) {
        item.disInVolume = item.disInVolume + data.new.inVolume
        item['inVolumeDiff'] = parseInt(item['inVolume'] - item['disInVolume'])
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/distribution_writeoff/writeoff_invoicing.js